import React from 'react';
import { Figure } from './Figure';
type ImageFigureProps = {
  src: string;
  alt: string;
  caption?: string;
  className?: string;
  /** Background behind the image, for screenshots with transparent or dark edges. */
  dark?: boolean;
  /** For tall diagrams: sits the image inside a padded white panel at a narrower width. */
  padded?: boolean;
};

/** A case-study screenshot or diagram: full width, rounded, with a hairline border and an optional caption. */
export function ImageFigure({
  src,
  alt,
  caption,
  className,
  dark,
  padded
}: ImageFigureProps) {
  return <Figure className={className} caption={caption} data-id="element-122" data-mp="wg4v874uf991">
      <div className={`overflow-hidden rounded-2xl border border-line ${dark ? 'bg-[#3A3A3A]' : 'bg-white'} ${padded ? 'px-5 py-8 md:px-10 md:py-12' : ''}`} data-id="element-123" data-mp="wgwnp9358qv3">
        <img src={src} alt={alt} loading="lazy" decoding="async" className={`block h-auto w-full ${padded ? 'mx-auto max-w-xl' : ''}`} data-id="element-124" data-mp="3yj002biul9q" />
      </div>
    </Figure>;
}